export default function useRegexp() {
  const mailRegexp = /^[a-zA-Z0-9_.+-]+@([a-zA-Z0-9][a-zA-Z0-9-]*[a-zA-Z0-9]*\.)+[a-zA-Z]{2,}$/;

  return {
    mailRegexp,
  };
}
